import React from 'react';

export default function SelectForm({ setFormType, formType }) {
  const handleFormSelection = (type) => {
    setFormType(type);
  };

  return (
    <section className="section">
      <div className="container container--xl">
        <div className="section__header">
          <h4 className="section__header-text">Event Details</h4>
        </div>
        <div className="options-events">
          <div className="grid grid--std grid--sm-screen">
            <div className=" grid__col-xs-12 grid__col-md-6 grid__col-lg-6">
              <div
                className={`options-events__container ${
                  formType === 'free' ? 'active' : ''
                }`}
                onClick={() => handleFormSelection('free')}
              >
                <div className="options-events__content">
                  <h4>Free</h4>
                  <p className="options-events__price">$0</p>
                  <ul>
                    <li>
                      <i className="icon-check"></i>
                      <p>List your event for free on TexasCoopPower.com</p>
                    </li>
                    <li>
                      <i className="icon-check"></i>
                      <p>Events appear under the website calendar</p>
                    </li>
                  </ul>
                  <a className="btn btn--blue">Add Your Event Now</a>
                </div>
              </div>
            </div>
            <div className="grid__col-xs-12 grid__col-md-6 grid__col-lg-6">
              <div
                className={`options-events__container paid-event ${
                  formType === 'paid' ? 'active' : ''
                }`}
                onClick={() => handleFormSelection('paid')}
              >
                <div className="options-events__content">
                  <h4>Featured Event</h4>
                  <p className="options-events__price">From $25 for 30 days</p>
                  <ul>
                    <li>
                      <i className="icon-check"></i>
                      <p>
                        Your event will appear under a featured event section as
                        well as linked to a standalone information page
                      </p>
                    </li>
                    <li>
                      <i className="icon-check"></i>
                      <p>A longer text description</p>
                    </li>
                    <li>
                      <i className="icon-check"></i>
                      <p>
                        Your Event image (1200px x 800 px, maximum file size 2
                        MB). Other image sizes will be cropped to fit the space.
                      </p>
                    </li>
                    <li>
                      <i className="icon-check"></i>
                      <p>A PDF or Word file attachment (maximum 2 MB)</p>
                    </li>
                    <li>
                      <i className="icon-check"></i>
                      <p>
                        A google locator map (automatically generated from the
                        address information you enter)
                      </p>
                    </li>
                    <li>
                      <i className="icon-check"></i>
                      <p>
                        Your event receives increased visibility in the Featured
                        Events section on TexasCoopPower.com for up to 120 days
                        before the event start date.
                      </p>
                    </li>
                  </ul>
                  <a className="btn btn--blue">Add Your Event Now</a>
                  <p className="options-events__disclaimer">
                    Upgrading to a Featured Event does not guarantee your
                    listing will appear in the magazine.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
